import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';
import {
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
} from '@welldev-group/rcl-table';
import ConfirmationModal from '../../../../../../shared/components/ConfirmationModal';
import WorkspaceTableRow from './WorkspaceTableRow';
import TablePlaceholder from '../../../../../../shared/components/Placeholder/TablePlaceHolder';
import EmptyTableContent from '../../../../../../shared/components/EmptyTableContent';
import SanitizedHTML from '../../../../../../shared/components/SanitizedHTML';

const WorkspaceTable = ({
  workspaces,
  isLoading,
  setIsConfirmationModalOfUpdatingWorkspaceOpen,
  fetchWorkspaces,
  deleteWorkspace,
  status,
  userAffiliateId,
  affiliateId,
}) => {
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [isDeactivateModalOpen, setIsDeactivateModalOpen] = useState(false);

  const onDeactivateWorkspaceClick = workspace => {
    setSelectedWorkspace(workspace);
    setIsDeactivateModalOpen(true);
  };

  const onDeactivateWorkspace = () => {
    deleteWorkspace(selectedWorkspace.id)
      .then(() => {
        setIsDeactivateModalOpen(false);
      })
      .catch(() => {
        setIsDeactivateModalOpen(false);
      });
  };

  const openConfirmationModalOfUpdatingWorkspace = workspace => {
    setSelectedWorkspace(workspace);
    setIsConfirmationModalOfUpdatingWorkspaceOpen(true);
  };

  return (
    <>
      <Table className="affiliate-workspace-list__table">
        <TableHead>
          <TableRow>
            <TableHeader>
              <I18nText id="affiliate_three_sixty.affiliate.workspaces.table.header.name" />
            </TableHeader>
            <TableHeader>
              <I18nText id="affiliate_three_sixty.affiliate.workspaces.table.header.identifier" />
            </TableHeader>
            <TableHeader align="center">
              <I18nText id="affiliate_three_sixty.affiliate.workspaces.table.header.url" />
            </TableHeader>
            <TableHeader align="center">
              <I18nText id="affiliate_three_sixty.affiliate.workspaces.table.header.action" />
            </TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {isLoading ? (
            <TablePlaceholder numberOfColumn={4} numberOfRows={10} />
          ) : (
            workspaces.map(workspace => (
              <WorkspaceTableRow
                key={workspace.id}
                workspace={workspace}
                status={status}
                openConfirmationModalOfUpdatingWorkspace={
                  openConfirmationModalOfUpdatingWorkspace
                }
                onDeactivateWorkspaceClick={onDeactivateWorkspaceClick}
                affiliateId={affiliateId}
                userAffiliateId={userAffiliateId}
                fetchWorkspaces={fetchWorkspaces}
              />
            ))
          )}
        </TableBody>
      </Table>
      {!isLoading && !workspaces.length && <EmptyTableContent />}
      <ConfirmationModal
        confirmationHeader={
          <I18nText id="affiliate_three_sixty.affiliate.workspaces.deactivate.header" />
        }
        subHeader={
          <span className="affiliate-workspace-list__confirmation-message">
            <SanitizedHTML
              html={I18n.t(
                'components.affiliate_three_sixty.affiliate.workspaces.deactivate.message',
                { workspace: selectedWorkspace && selectedWorkspace.name },
              )}
            />
          </span>
        }
        type="warning"
        isModalOpen={isDeactivateModalOpen}
        withAction={true}
        rejectionText={
          <I18nText id="affiliate_three_sixty.affiliate.workspaces.deactivate.cancel" />
        }
        confirmationText={
          <I18nText id="affiliate_three_sixty.affiliate.workspaces.deactivate.button" />
        }
        onConfirm={() => onDeactivateWorkspace()}
        onReject={() => setIsDeactivateModalOpen(false)}
      />
    </>
  );
};

WorkspaceTable.propTypes = {
  workspaces: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      verified: PropTypes.bool.isRequired,
      teams: PropTypes.arrayOf(PropTypes.string),
      lastActive: PropTypes.string.isRequired,
      action: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  isLoading: PropTypes.bool.isRequired,
  fetchWorkspaces: PropTypes.func.isRequired,
  setIsConfirmationModalOfUpdatingWorkspaceOpen: PropTypes.bool.isRequired,
  deleteWorkspace: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  userAffiliateId: PropTypes.number.isRequired,
  affiliateId: PropTypes.number.isRequired,
};

export default WorkspaceTable;
